// extracted by mini-css-extract-plugin
export var btnMain = "style-module--btn--main--6b708";
export var btnRestart = "style-module--btn--restart--390b7";